import requestJson from '../../../modules/requestJson';
import PatchHistoryItem from '../../history/PatchHistoryItem';

const MAX_PATCH_HISTORY_ITEMS = 10;

/**
 * Returns any patch history items for the given app project after (exclusive) the given
 * version (which must be a properly formatted ISO string).
 *
 * @param appId app ID
 * @param afterVersion the version (exclusive) after which history items are listed
 */
export default async function listAppProjectPatchHistoryItemsSince(
  appId: string,
  afterVersion: string,
): Promise<PatchHistoryItem[]> {
  const historyItems = await requestJson<PatchHistoryItem[]>(
    'GET',
    `/app-editor/v1/projects/${encodeURIComponent(appId)}/descriptor/patches?since=${encodeURIComponent(
      afterVersion,
    )}&limit=${MAX_PATCH_HISTORY_ITEMS}`,
  );
  const lastHistoryItem = historyItems.at(-1);
  if (historyItems.length < MAX_PATCH_HISTORY_ITEMS || !lastHistoryItem) {
    return historyItems;
  }
  // The maximum number of history items were returned, so there might be more.
  // Recursively list more after the last history item.
  const lastVersion = lastHistoryItem.reverse_against;
  const restOfHistoryItems = await listAppProjectPatchHistoryItemsSince(appId, lastVersion);
  return [...historyItems, ...restOfHistoryItems];
}
